import { messages, TwilioVerificationChannelEnum, useTwilioSendCodeMutation } from '@alluradirect/react';
import { SendCodeForm } from 'components/views/verification/components/SendCodeForm';
import { VerificationStepEnum } from 'components/views/verification/VerificationDialog';
import { Form, Formik } from 'formik';
import { useMemo } from 'react';
import * as yup from 'yup';

export interface SendCodeValues {
  data: string;
  is_taken: boolean;
  is_call: boolean;
}

const emailValidation = yup.object().shape({
  data: yup
    .string()
    .required(messages.requiredValue)
    .min(3, 'Email must be at least 3 characters')
    .email('Please enter a valid email'),
  is_taken: yup
    .boolean()
    .required(messages.requiredValue)
    .test('is false', 'email taken by another user', (value: any) => value !== true),
});

const phoneValidation = yup.object().shape({
  data: yup.string().required(messages.requiredValue).min(5, 'Phone number must be at least 5 characters'),
  is_taken: yup
    .boolean()
    .required(messages.requiredValue)
    .test(
      'is false',
      'The phone number you have used is already being used by another alluraDirect account.',
      (value: any) => value !== true,
    ),
});

export const SendCodeFormWrapper = ({
  data,
  channel,
  setStep,
  handleCloseDialog,
  setData,
}: {
  data: string;
  channel: TwilioVerificationChannelEnum.sms | TwilioVerificationChannelEnum.email;
  handleCloseDialog: () => void;
  setStep: React.Dispatch<React.SetStateAction<VerificationStepEnum>>;
  setData: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const sendCode = useTwilioSendCodeMutation();

  const validationSchema = useMemo(() => {
    if (channel === TwilioVerificationChannelEnum.sms) {
      return phoneValidation;
    } else if (channel === TwilioVerificationChannelEnum.email) {
      return emailValidation;
    } else {
      return `Channel: ${channel} not implemented`;
    }
  }, [channel]);

  return (
    <Formik
      initialValues={{ data, is_taken: false } as SendCodeValues}
      initialTouched={{
        is_taken: true,
      }}
      validationSchema={validationSchema}
      onSubmit={({ data, is_call }, { setSubmitting }) => {
        sendCode.mutate(
          { value: data, channel: is_call ? TwilioVerificationChannelEnum.call : channel },
          {
            onSuccess: () => {
              setData(data);
              setStep(VerificationStepEnum.VerifyCode);
            },
            onSettled: () => {
              setSubmitting(false);
            },
          },
        );
      }}
    >
      <Form>
        <SendCodeForm channel={channel} handleCloseDialog={handleCloseDialog} />
      </Form>
    </Formik>
  );
};
